// NOTE: This file is included in nav.js, making it included on every page.
// There is no need to manually add this to individual pages.
(function onPageLoad() {
  // Accordion hover style should only apply to the unchecked elements - provide
  // a CSS class to make that possible:
  Array.from(document.querySelectorAll('.accordion-js input')).forEach(input => {
    input.addEventListener('click', () => {
      Array.from(input.closest('.accordion-js').querySelectorAll('label'))
        .filter(label => label !== input.closest('label'))
        .forEach(label => label.classList.remove('checked'));
      input.closest('label').classList.toggle('checked');
    });
  });
})();
